import { TRootState } from '@/redux/rootReducer';

export const bookingsReviewSelector = (state: TRootState) => state.bookingsReview;
